<template>
    <div class="mr-3">
        <a @click="onMenu">
            <div class="nav-dropdown" >
                <v-icon color="primary" class="nav-icon mr-2">mdi-bell-outline</v-icon>
                <v-badge
                    :content="total"
                    :color="totalColor"
                    :tile="true"
                />
                <i class="nav-icon fas fa-caret-down" style="margin-left: 20px; font-size: 22px!important;"></i>
            </div>
        </a>
    </div>
</template>

<script>

import Inc from "@/modules/inc/service/Inc.js";

const Const = {
    state: {
        notempty: "red",
    }
}

export default {
    name: "CrmReminderMenu",
    components: {
    },

    props: {
        value: {
            required: true
        }
    },

    computed: {
        total() {
            return "" + this.$store.getters.total;
        },

        totalColor() {
            return this.$store.getters.total > 0 ? Const.state.notempty : this.$vuetify.theme.themes.light.primary;
        }
    },

    created() {
        this.loadTotal();
        this.$bus.$on(Inc.events.journal, this.loadTotal);
    },

    beforeDestroy() {
        this.$bus.$off(Inc.events.journal, this.loadTotal);
    },

    methods: {
        onMenu () {
            this.$emit("input", true);
        },

        async loadTotal() {
            await this.$store.dispatch('getTotalReminderByUser');
            await this.$store.dispatch('getReminderByUser');
        },
    }
}
</script>

<style scoped>

</style>